import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { request } from '../../../constants/constants';
import Swal from 'sweetalert2';

class InviteUser extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit = e => {
        e.preventDefault();
        e.target.classList.add('was-validated');
        if( e.target.checkValidity()) {
            this.setState({
                isLoading: true
            })
            const data = {
                email: this.state.email,
                username: this.state.username,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
            }
            request('POST', '/auth/user/invite', data, true).then(res => {
                console.log(res);
                this.setState({
                    isLoading: false
                })
                Swal.fire(
                    'Success',
                    res.data.message,
                    'success'
                )
            }).catch(err => {
                console.error(err);
                this.setState({
                    isLoading: false
                })
                Swal.fire(
                    'Error',
                    err.response.data.message,
                    'error'
                )
            })
        }
    }

    render() {
        return (
            <div className="page-body">
                <div className="container-fluid">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="page-header-left">
                                    <h3>Invite User
                            {/* <small></small> */}
                                    </h3>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <ol className="breadcrumb pull-right">
                                    <li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg></Link></li>
                                    <li className="breadcrumb-item">Users</li>
                                    <li className="breadcrumb-item active">Invite</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>User Details</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row product-adding">
                                        <div className="col-xl-6">
                                                <div className="row">
                                                    <div className="col-xl-9 xl-50 col-sm-6 col-9">
                                                        <form onSubmit={this.handleSubmit} className="needs-validation add-product-form" noValidate>
                                                            <div className="form">
                                                                <div className="form-group mb-3 row">
                                                                    <label htmlFor="validationCustom01" className="col-xl-3 col-sm-4 mb-0">First Name :</label>
                                                                    <input name="first_name" onChange={this.handleChange} className="form-control col-xl-8 col-sm-7" id="validationCustom01" type="text" required />
                                                                    <div className="valid-feedback">Looks good!</div>
                                                                </div>
                                                                <div className="form-group mb-3 row">
                                                                    <label htmlFor="validationCustom01" className="col-xl-3 col-sm-4 mb-0">Last Name :</label>
                                                                    <input name="last_name" onChange={this.handleChange} className="form-control col-xl-8 col-sm-7" id="validationCustom01" type="text" required />
                                                                    <div className="valid-feedback">Looks good!</div>
                                                                </div>
                                                                <div className="form-group mb-3 row">
                                                                    <label htmlFor="validationCustom02" className="col-xl-3 col-sm-4 mb-0">Email :</label>
                                                                    <input name="email" type="email" onChange={this.handleChange} className="form-control col-xl-8 col-sm-7" id="validationCustom02" required />
                                                                    <div className="valid-feedback">Looks good!</div>
                                                                </div>

                                                                <div className="form-group mb-3 row">
                                                                    <label htmlFor="validationCustom02" className="col-xl-3 col-sm-4 mb-0">Username :</label>
                                                                    <input name="username" type="text" onChange={this.handleChange} className="form-control col-xl-8 col-sm-7" id="validationCustom02" required />
                                                                    <div className="valid-feedback">Looks good!</div>
                                                                </div>

                                                                {/* <div className="form-group mb-3 row">
                                                                    <label htmlFor="validationCustom02" className="col-xl-3 col-sm-4 mb-0">Description :</label>
                                                                    <textarea name="description" onChange={this.handleChange} className="form-control col-xl-8 col-sm-7" id="validationCustom02" type="text" />
                                                                    <div className="valid-feedback">Looks good!</div>
                                                                    <div className="invalid-feedback offset-sm-4 offset-xl-3">Please choose Valid Code.</div>
                                                                </div> */}

                                                            </div>
                                                            <div className="mt-4">
                                                                <button type="submit" className="btn btn-primary">
                                                                    {this.state.isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Invite'}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                        </div>
                                        {/* <div className="col-xl-7">

                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InviteUser;